import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, type ShiftTask, type ICreateTask } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { useApiWithReject } from "@/utility/utils";

export const useCreateShiftTask = () => {
    const { current: session } = useContext(SessionContext);
    const queryClient = useQueryClient();
    const createTaskApi = useApiWithReject(api.hooks.shift.createTask());

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useMutation<ShiftTask, Error, ICreateTask>({
        mutationFn: async (payload) => {
            if (!session?.context) {
                throw new Error("Session context not available");
            }
            return createTaskApi.send(session.context, payload);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ["shiftTasks", userUuid, tenantId] });
        },
    });
};
